export enum EnumCentroCustoOrigem {
    TELA_CADASTRAL = 1,
    OBRA = 2
}

export type TypeCentroCustoOrigem = {
    codigo?: number,
    descricao?: string
}
